export const PopupWinPriority = {
    WIN_FOR_NEW: 10000,
    WIN_FOR_APP: 1000,
    WIN_FOR_MODULE: 100,
    HINT_FOR_SUB_MODULE: 10,
    HINT_FOR_GUIDE: 1,
};
export const AllPopWinState = {
    registeredPopUpWinMap: {},
    currentShowedPopUpWin: null,
    lastShowedPopUpWin: null,
    globalCurShowProps: {},
    globalLastShowProps: {},
    localDataLoaded: false,
    popWinReady: false,
    showNewUserGuide: false,
};
